export interface INavigationRoute {
  name: string
  displayName: string
  meta: { icon: string }
  children?: INavigationRoute[]
}

export default {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'dashboard',
      displayName: 'menu.dashboard',
      meta: {
        icon: 'vuestic-iconset-dashboard',
      },
    },
    {
      name: 'users',
      displayName: 'menu.users',
      meta: {
        icon: 'group',
      },
      children: [
        {
          name: 'users-list',
          displayName: 'menu.usersList',
        },
        {
          name: 'users-admins',
          displayName: 'menu.usersAdmins',
        },
      ],
    },
    {
      name: 'games',
      displayName: 'menu.games',
      meta: {
        icon: 'sports_esports',
      },
    },
    {
      name: 'tags',
      displayName: 'menu.tags',
      meta: {
        icon: 'label',
      },
    },
    {
      name: 'posts',
      displayName: 'menu.posts',
      meta: {
        icon: 'article',
      },
    },
    {
      name: 'finance',
      displayName: 'menu.finance',
      meta: {
        icon: 'account_balance_wallet',
      },
      children: [
        {
          name: 'wallets',
          displayName: 'menu.wallets',
        },
        {
          name: 'transactions',
          displayName: 'menu.transactions',
        },
        {
          name: 'tokens',
          displayName: 'menu.tokens',
        },
      ],
    },
    {
      name: 'promotions',
      displayName: 'menu.promotions',
      meta: {
        icon: 'campaign',
      },
    },
    {
      name: 'audit-events',
      displayName: 'menu.auditEvents',
      meta: {
        icon: 'history',
      },
    },
    {
      name: 'auth',
      displayName: 'menu.auth',
      meta: {
        icon: 'login',
      },
      children: [
        {
          name: 'login',
          displayName: 'menu.login',
        },
        {
          name: 'signup',
          displayName: 'menu.signup',
        },
        {
          name: 'recover-password',
          displayName: 'menu.recover-password',
        },
      ],
    },
    {
      name: 'preferences',
      displayName: 'menu.preferences',
      meta: {
        icon: 'manage_accounts',
      },
    },
    {
      name: 'settings',
      displayName: 'menu.settings',
      meta: {
        icon: 'settings',
      },
    },
  ] as INavigationRoute[],
}
